import {Cascader} from 'antd'
import {createValue} from 'components/form/utils'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import _ from 'lodash'
import {useAppConfig} from 'modules/local/AppConfigContext'
import Translate from 'modules/local/Translate'
import React, {useContext, useMemo} from 'react'
import {dropdownComponents,} from 'views/AppLocals/custom/ReactSelectComponents'
import {NullAsDefault, renderOwnChild} from 'views/Shared'

const renderDefaultLabel = ({name, type}) => (type ? `${type} ${name}` : name)

export const getDeaneryOptions = ({
                                      deaneries,
                                      dioceses,
                                      archdioceses,
                                      country_id,
                                      renderLabel = renderDefaultLabel,
                                  }) => {
    const getDeaneries = (diocese_id) =>
        _.filter(Array.from(deaneries || []), {diocese_id}).map(
            ({id, name, type}) => ({
                value: id,
                label: renderLabel({
                    name,
                    type,
                })
            })
        )

    const getDioceses = (archdiocese_id) =>
        _.filter(Array.from(dioceses || []), {archdiocese_id}).map(
            ({id, name, type}) => ({
                value: id,
                label: renderLabel({
                    name,
                    type,
                }),
                children: getDeaneries(id),
            })
        )

    return _.filter(Array.from(archdioceses || []), {country_id}).map(
        ({id, name, type}) => ({
            value: id,
            label: renderLabel({
                name,
                type,
            }),
            children: getDioceses(id),
        })
    )
}

export const DeaneryCascade = ({
                                   name,
                                   value,
                                   onChange,
                                   country_id,
                                   defaultValue,
                                   Header = NullAsDefault,
                                   renderLabel,
                                   Wrapper = renderOwnChild,
                                   ...props
                               }) => {
    const {isSm} = useContext(LayoutContext)

    const {archdioceses = [], dioceses = [], deaneries = []} = useAppConfig('archdioceses', 'dioceses', 'deaneries')

    const handleChange = (value) => {
        onChange(createValue(name, value))
    }

    const options = useMemo(
        () =>
            getDeaneryOptions({
                archdioceses, dioceses, deaneries,
                country_id,
                renderLabel: isSm ? ({name}) => name : renderDefaultLabel,
            }),
        [isSm, archdioceses, dioceses, deaneries, country_id]
    )

    if (_.isEmpty(options)) return null

    return (
        <Wrapper>
            <Header/>
            <Translate>
                {(translate) => (
                    <Cascader
                        showSearch={true}
                        // changeOnSelect={true}
                        suffixIcon={<dropdownComponents.DropdownIndicator/>}
                        {...props}
                        value={value}
                        options={options}
                        onChange={handleChange}
                        // className="block w-full"
                        style={{
                            width: '100%',
                        }}
                        placeholder={translate('click to select')}
                        defaultValue={defaultValue}
                        displayRender={(stringArray = []) =>
                            stringArray.every(_.isEmpty)
                                ? <span className="text-xs text-color-500 italic">{translate('click to select')}</span>
                                : stringArray.join(' / ')
                        }
                    />
                )}
            </Translate>
        </Wrapper>
    )
}

export const renderDeaneryCascade = ({Header, ...props}) => (
    <DeaneryCascade
        Header={Header}
        {...props}
    />
)

